// theme.js or theme.ts
import { createTheme } from '@mui/material/styles';
import type { } from '@mui/x-data-grid-pro/themeAugmentation';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#2CA01C', // QuickBooks green
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#004F2D', // deep green accent
        },
        background: {
            default: '#F5F7FA', // light neutral gray
            paper: '#ffffff',
        },
        text: {
            primary: '#1F2937', // dark slate
            secondary: '#4B5563',
        },
        divider: '#E5E7EB',
        success: {
            main: '#28A745', // similar to primary
        },
        warning: {
            main: '#FFC107',
        },
    },
    typography: {
        fontFamily: 'Inter, Roboto, Arial, sans-serif',
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 600,
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#323437',
                    color: '#ffffff',
                },
            },
        },
        MuiButton: {
            defaultProps: {
                size: 'small',
            },
            styleOverrides: {
                root: {
                    minHeight: 32,
                    padding: '4px 12px',
                    fontSize: '0.8rem',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiSelect: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiFormControl: {
            defaultProps: {
                margin: 'dense',
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem',
                    minHeight: 36,
                    display: 'flex',
                    alignItems: 'center', 
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: '0.75rem',
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                row: {
                    borderBottom: "1px solid #E1E1E1 !important", // darker gray line between rows
                    "&:nth-of-type(odd)": {
                        backgroundColor: "#ffffff", // white
                    },
                    "&:nth-of-type(even)": {
                        backgroundColor: "#f7f7f7", // light gray
                    },
                    "&:hover": {
                        backgroundColor: "#eaeaea !important", // optional hover
                    },
                },
            },
        },

    },
});
export default theme;
